import React from 'react';

import { useTranslation } from 'hooks';
import useArrivalTime from 'BookingFlow/PersonaliseYourStay/hooks/useArrivalTime';
import classNames from 'classnames';
import Dropdown from './Dropdown';

export default React.forwardRef(({ value, onChange, disabled, label, error }, _ref) => {
	const { t } = useTranslation();

	const {
		hour,
		minute,
		meridiem,
		handleChangeHour,
		handleChangeMinute,
		handleChangeMeridiem,
		HOURS,
		MINUTES,
		MERIDIEMS,
	} = useArrivalTime({ value, onChange });

	const hourValue = `${['12', '00'].includes(hour) ? 12 : hour % 12}`;

	return (
		<div
			className={classNames('arrival-time', {
				'arrival-time-error': !!error,
			})}
		>
			<div className="arrival-time-selects">
				<Dropdown
					name="checkInTimeHour"
					label={label || t('ETA')}
					identifier="checkInTimeHour"
					value={hourValue}
					onChange={handleChangeHour}
					options={HOURS}
					disabled={disabled}
					required
					error={!!error}
					aria-label={t('Arrival Time Hour')}
				/>
				<Dropdown
					name="checkInTimeMinutes"
					identifier="checkInTimeMinutes"
					value={`${minute}`}
					onChange={handleChangeMinute}
					options={MINUTES}
					disabled={disabled}
					required
					error={!!error}
					aria-label={t('Arrival Time Minute')}
				/>
				<Dropdown
					name="checkInTimePeriod"
					identifier="checkInTimePeriod"
					value={meridiem}
					onChange={handleChangeMeridiem}
					options={MERIDIEMS}
					disabled={disabled}
					required
					error={!!error}
					aria-label={t('Arrival Time AM/PM')}
				/>
			</div>
			{error && (
				<div className="error-message">
					<span className="formElement-message" role="alert">
						{error}
					</span>
				</div>
			)}
		</div>
	);
});
